import * as React from "react";
// import Button from '@mui/material/Button';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { width } from "@mui/system";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import ReactModal from "./Modal/AddModalCustomer";
import useModal from "../../hooks/useModal";
import useAddModal from "../../hooks/useAddModal";
import { use } from "i18next";
import styled from "styled-components";
import { t } from "i18next";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* Semi-transparent black */
  backdrop-filter: blur(1px); /* Blur the background */
  z-index: 999; /* Make sure it appears above everything else */
`;

export default function UntagFeedbackDialog({ open, setOpen, returnComment }) {
  //   const [open, setOpen] = React.useState(false);

  //   const handleClickOpen = () => {
  //     setOpen(true);
  //   };
  const { isOpen, toggleModal, val } = useAddModal();
  const [text, setText] = React.useState(null);
  const handleClose = () => {
    console.log("handleClose", text);
    returnComment(text);
    setOpen(false);
    toggleModal();
  };
  const handleTextFieldChange = (event) => {
    console.log(event.target.value);
    setText(event.target.value);
  };
  const cancelledOperation = () => {
    returnComment(null);
    setText(null);
    setOpen(false);
    toggleModal();
  };
  React.useEffect(() => {
  setText(null);
    if (open) {
      toggleModal();
    }
  }, [open]);
  return (
    <>
      {open && isOpen && <Overlay />}
      <ReactModal
        show={open && isOpen}
        handleClose={() => {
          toggleModal();
          setOpen(false);
        }}
        componentToRender={
          <>
            <Row>
              <Col lg="12" className="mb-3">
                <Form.Label>{t("general.lable.untag.reason")} <i className="text-danger">*</i></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  required
                  placeholder="Comment"
                  onChange={handleTextFieldChange}
                />
              </Col>
              <Col lg="12" className="text-end">
                <Button
                  variant="outline-dark"
                  className="ms-2"
                  onClick={cancelledOperation}
                >
                  {t('general.button.cancel.label')}
                </Button>
                <Button
                  disabled={(typeof text !== "string") || (typeof text === "string" && text.length <= 0)}
                  variant="primary"
                  className="ms-2"
                  onClick={handleClose}
                >
                  {t('general.button.submit.label')}
                </Button>
              </Col>
            </Row>
          </>
        }
        title={"Confirmation"}
        size={"sm"}
        modalId={"confirmationModal"}
        centered
      />
      {/* <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: "35vw",
        },
        component: 'form',
        onSubmit: (event) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries(formData.entries());
          const email = formJson.comment;
          console.log(email);
          setText(textFieldValue);
          handleClose();
        },
      }}
    > */}

      {/* <Card>
        <Card.Body> */}
      {/* <DialogTitle>Confirmation</DialogTitle> */}

      {/* <Col lg="12" className='mb-3'>
            <Form.Label>Please add your reason.</Form.Label>
            <Form.Control as="textarea" rows={3} required placeholder='Comment' onChange={handleTextFieldChange} /> */}

      {/* <DialogContentText>
            Please add your reason.
          </DialogContentText> */}
      {/* <TextField
            autoFocus
            required
            margin="dense"
            id="comment"
            name="comment"
            label="Comment"
            type="text"
            fullWidth
            variant="standard"
            onChange={handleTextFieldChange}
          /> */}
      {/* </Col>
          <Col lg="12" className='text-end'>
            <Button variant="outline-dark" className='ms-2' onClick={cancelledOperation}>Cancel</Button>
            <Button variant="primary" className='ms-2' type="submit">Submit</Button>
          </Col>
        </Card.Body>
      </Card>

    </Dialog> */}
    </>
  );
}
